import { useSelector } from 'react-redux';
import Global from '../store/global-selectors';

export const useIsVendorOr3PL = () => {
  const { isVendorOr3PL } = useSelector(Global.selectSellerSubscriptionPlanInfo) || {};
  return isVendorOr3PL;
};
